import BybVrSlider from "@Components/game/common/dialog/byb-vr-slider";
import { GameModeCard } from "@Components/game/game-mode";
import { usePractiseContext } from "@Context/game/practise/practise-context";
import { AnalyticsEvents } from "@Enums/index";
import { useAnalytics } from "@hooks/common/analytics/use-analytics";
import useI18n from "@i18n";
import { Fade, Stack, Typography, useTheme } from "@mui/material";

const RatingConfig = () => {
  const { i18n } = useI18n();
  const theme = useTheme();
  const { sessionOptions, setSessionOptions, allDivisions, playersDivision, isAboveMax } = usePractiseContext();
  const { track } = useAnalytics();

  const handleRatingChange = (event: Event, newValue: number | number[]) => {
    const selectedIndex = newValue as number;
    const selectedDivision = allDivisions[selectedIndex];
    if (selectedDivision) {
      setSessionOptions({
        ...sessionOptions,
        rating: selectedDivision.rating_point,
      });
      track(AnalyticsEvents.practice_settings_adjusted, { rating: selectedDivision.rating_point });
    }
  };

  const currentRatingIndex = allDivisions.findIndex(division => division.rating_point === sessionOptions.rating);
  const playerDivisionIndex = allDivisions.findIndex(division => division.rating_point === playersDivision?.rating_point);
  const maxRatingIndex = allDivisions.findIndex(division => division.rating_point === (playersDivision?.rating_point || 0) + 1000);

  return (
    <GameModeCard>
      <Stack spacing={1.5}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="text1xl500" color="dsNeutral.v300">
            {i18n("practice.difficulty")}
          </Typography>
          <Stack direction="row" spacing={2}>
            <Fade in={isAboveMax} timeout={300}>
              <Typography
                variant="textS500"
                color="error.main"
                sx={{
                  textAlign: "center",
                  minHeight: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {i18n("practice.level-not-available")}
              </Typography>
            </Fade>
            <Typography variant="text1xl500" color="dsBase.v200">
              {sessionOptions.rating || 0}
            </Typography>
          </Stack>
        </Stack>
        <BybVrSlider
          value={currentRatingIndex >= 0 ? currentRatingIndex : 0}
          onChange={handleRatingChange}
          min={0}
          max={allDivisions.length - 1}
          step={1}
          marks={[
            {
              value: playerDivisionIndex >= 0 ? playerDivisionIndex : 0,
            },
            {
              value: maxRatingIndex >= 0 ? maxRatingIndex : allDivisions.length - 1,
              label: i18n("max"),
            },
          ]}
        />
      </Stack>
    </GameModeCard>
  );
};

export default RatingConfig;
